<template>
  <!-- 信息发布详情 -->
  <div class="page-info-publish-detail">
    <div class="wrap">
      <div class="header">
        <h1 class="tc">{{detailData.title}}</h1>
        <p class="tc">发布时间 {{detailData.createTimeStr}}</p>
      </div>

      <div class="content" v-html="detailData.content"></div>

      <div class="footer">
        <div class="pic-box">
          <img :src="detailData.createrImage||''" alt="" :onerror="defaultHeadImg">
          <span class="ml-5">{{detailData.createrName}}</span>
        </div>
        <span class="ml-20" v-if="detailData.createrDeptName">{{detailData.createrDeptName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      detailData: {}
    }
  },
  methods: {
  },
  created() {
    this.detailData = JSON.parse(decodeURIComponent(this.$route.query.obj))
  }
}
</script>

<style lang="scss" scoped>
.page-info-publish-detail {
  height: 100vh;
  overflow-y: auto;
  background: #f2f3f8;
  padding: 20px 0;
  box-sizing: border-box;
  .wrap {
    width: 1200px;
    margin: auto;
    min-height: calc(100vh - 60px);
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333;
    .header {
      color: #7f7f7f;
      h1 {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
    .content {
      padding: 20px 0;
      min-height: 500px;
      text-align: justify;
      line-height: 1.6;
      word-break: word-break;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      .pic-box {
        display: flex;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          border-radius: 100%;
        }
      }
    }
  }
}
</style>